module.exports = __webpack_public_path__ + "img/noon.a435ab1a.svg";